import React from "react";
import {
   ExpansionPanel,
   ExpansionPanelDetails, makeStyles,
   Table,
   TableBody,
   TableCell,
   TableHead,
   TableRow
} from "@material-ui/core";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import {useTranslation} from "react-i18next";
import _ from 'lodash';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import styled from "styled-components";


const theme = createMuiTheme({
   overrides: {
      MuiTableCell: {
         root: {
            padding: '5px 16px'
         }
      }
   }
});

const useStyles = makeStyles(theme => ({
   root: {
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: '1rem 2rem',
      overflowY: 'scroll',
   },
   gt: {
      marginBottom: '1rem'
   },
   gtTitle: {
      backgroundImage: 'none',
      borderBottom: '2px solid #0D5B83',
      minHeight: '55px !important',
      webkitUserSelect: 'auto !important',
      userSelect: 'auto !important',
   },
   gtTitleText: {
      color: '#0D5B83',
      padding: '0 !important',
      fontSize: theme.typography.pxToRem(21)
   },
   gtHeader: {
      backgroundColor: '#E1E7E9'
   },
   row: {},
   cell: {
      padding: '0px !important',
      height: '1.2rem',
      lineHeight: '1.2rem'
   }
}));

function Category(props) {
   const classes = useStyles();
   let percent = (props.count === 0) ? '0.0%' : _.floor((props.category.ac / props.count) * 100, 1) + "%"
   return (
      <TableRow style={{height: '30'}}>
         <TableCell align={'left'}>{props.category.no}</TableCell>
         <TableCell align={'left'} style={{wordWrap: 'break-word', wordBreak: 'break-all'}}>{props.category.n}</TableCell>
         <TableCell align={'left'}>{props.category.ac}</TableCell>
         <TableCell align={'left'}>{percent}
         </TableCell>
      </TableRow>
   )
}

function Question(props) {
   const {t} = useTranslation();
   const classes = useStyles();
   if (props.question.ig) {
      let questions = props.question.qs.map((q, index) => <Question key={index} question={q}
                                                                           index={index + 1}/>)
      return questions
   } else {
      if (!["sa", "SA", "ma", "MA"].includes(props.question.p.t)) {
         return <div></div>
      }
      let categories = props.question.c.map((cate, index) => <Category key={index} category={cate}
                                                                    count={props.question.ac}/>)

      return (<div className={classes.gt}>
         <ExpansionPanel expanded={true}>
            <ExpansionPanelSummary
               className={classes.gtTitle}
               style={{cursor: 'initial'}}>
               <div id={props.question.p.qn}>
                  <Typography
                     className={classes.gtTitleText} style={{wordWrap: 'break-word', wordBreak: 'break-all'}}>{props.question.p.qn}{props.index ? "_" + props.index : ""}({props.question.p.t}) {props.question.p.n}</Typography>
               </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{padding: '0.8rem 0 0 0'}}>
               <Table size="small">
                  <TableHead className={classes.gtHeader}>
                     <TableRow>
                        <TableCell style={{minWidth: 50}}></TableCell>
                        <TableCell style={{width: '100%'}}>{t('gt_headers_2')}</TableCell>
                        <TableCell style={{minWidth: 60}}>{t('gt_headers_0')}</TableCell>
                        <TableCell style={{minWidth: 60}}>{t('gt_headers_1')}</TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     <TableRow>
                        <TableCell colSpan={2}>{t('gt_all')}</TableCell>
                        <TableCell>{props.question.ac}</TableCell>
                        <TableCell>100.0%</TableCell>
                     </TableRow>
                     {categories}
                  </TableBody>
               </Table>
            </ExpansionPanelDetails>
         </ExpansionPanel>
      </div>)
   }

}

function Page(props) {
   let questions = props.questions.map((q, index) => <Question key={index} question={q}/>)
   return questions
}

function Survey(props) {
   if (!props.survey.answers) return <div></div>;
   let answers = JSON.parse(props.survey.answers);
   let pages = answers["pages"].map((q, index) => <Page key={index} questions={q.qs}/>);
   return pages;
}

let Root  = styled.div`
   height: calc(100vh - 3rem);
`;

function Tabulation(props) {
   const classes = useStyles();
   const {t} = useTranslation();
   let questions = <Survey survey={props.survey}/>;
   return (
      <Root className={classes.root} style={{width: '100%'}}>
         <div style={{display: 'flex', flexDirection: 'row-reverse', marginTop: '1rem'}}>
            <span>{t('updated_at')}{props.updatedAt}</span>
         </div>
         <div style={{display: 'flex', flexDirection: 'row-reverse', fontSize: '0.85rem', marginTop: '0.2rem'}}>
            <span>{t('update_text1')}</span>
         </div>
         {questions}
      </Root>
   )
}

export default Tabulation